import React from 'react';
import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

interface DiscoverEmptyStateProps {
  onAction: () => void;
}

const CURATED_RESTAURANTS = [
  { name: 'Farm Bloomington', cuisine: 'American' },
  { name: 'The Irish Lion', cuisine: 'Irish Pub' },
  { name: 'Uptown Cafe', cuisine: 'American' },
  { name: 'Janko\'s Little Zagreb', cuisine: 'Eastern European' },
  { name: 'Turkuaz Cafe', cuisine: 'Turkish' },
  { name: 'Feast', cuisine: 'International' },
];

export function DiscoverEmptyState({ onAction }: DiscoverEmptyStateProps) {
  return (
    <View className="px-4 pb-4">
      <Card className="items-center p-6 mb-6">
        <Text className="text-xl font-bold text-foreground text-center mb-2">
          Be the first to review somewhere near you
        </Text>
        <Text className="text-sm text-muted-foreground text-center mb-4">
          No one has reviewed a dish nearby yet. Explore a local restaurant and share your experience.
        </Text>
        <Button onPress={onAction} accessibilityLabel="Leave a Review">
          Leave a Review
        </Button>
      </Card>

      <Text className="text-lg font-bold text-foreground mb-3">
        Popular in Bloomington
      </Text>
      <View className="gap-2">
        {CURATED_RESTAURANTS.map((restaurant) => (
          <View
            key={restaurant.name}
            className="bg-card rounded-lg border border-border px-4 py-3 flex-row justify-between items-center"
          >
            <Text className="text-sm font-medium text-foreground">{restaurant.name}</Text>
            <Text className="text-xs text-muted-foreground">{restaurant.cuisine}</Text>
          </View>
        ))}
      </View>
    </View>
  );
}
